(() => {
  const body = document.body;
  const one = (selector, root = document) => root.querySelector(selector);
  const all = (selector, root = document) => [...root.querySelectorAll(selector)];
  const setLocked = () => body.classList.toggle('is-locked', !!document.querySelector('.is-open[data-mobile-menu], .is-open[data-search-panel], .is-open[data-cart-drawer]'));
  const openPanel = (panel) => { if (!panel) return; panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); setLocked(); };
  const closePanel = (panel) => { if (!panel) return; panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); setLocked(); };
  const menu = one('[data-mobile-menu]');
  const search = one('[data-search-panel]');
  const cartDrawer = one('[data-cart-drawer]');
  const toast = one('[data-toast]');

  all('[data-menu-open]').forEach((button) => button.addEventListener('click', () => { openPanel(menu); button.setAttribute('aria-expanded', 'true'); }));
  all('[data-menu-close]').forEach((button) => button.addEventListener('click', () => { closePanel(menu); one('[data-menu-open]')?.setAttribute('aria-expanded', 'false'); }));
  all('[data-search-open]').forEach((button) => button.addEventListener('click', () => { openPanel(search); window.setTimeout(() => one('input', search)?.focus(), 150); }));
  all('[data-search-close]').forEach((button) => button.addEventListener('click', () => closePanel(search)));
  all('[data-cart-open]').forEach((button) => button.addEventListener('click', () => openPanel(cartDrawer)));
  all('[data-cart-close]').forEach((button) => button.addEventListener('click', () => closePanel(cartDrawer)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') [menu, search, cartDrawer].forEach(closePanel); });

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EGP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100); }
    catch { return `${(cents / 100).toFixed(2)} ${currency}`; }
  };

  const refreshCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    all('[data-cart-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
    const heading = one('[data-cart-heading-count]');
    if (heading) heading.textContent = `(${cart.item_count})`;
    const content = one('[data-cart-content]');
    if (!content) return cart;
    if (!cart.item_count) {
      content.innerHTML = '<div class="hh-cart__empty"><p>Your soft essentials will appear here.</p><a class="hh-button hh-button--dark" href="/collections/all">Explore the collection</a></div>';
      return cart;
    }
    const lines = cart.items.map((item) => `<div class="hh-cart-item"><a href="${item.url}">${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}">` : ''}</a><div><a href="${item.url}">${item.product_title}</a><small>${item.variant_title || ''} · ${item.quantity}</small><span>${formatMoney(item.final_line_price)}</span></div></div>`).join('');
    content.innerHTML = `${lines}<div class="hh-cart__total"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div><a class="hh-button hh-button--dark" href="/cart">View bag</a><form action="/cart" method="post"><button class="hh-button hh-button--outline" type="submit" name="checkout">Checkout securely</button></form>`;
    return cart;
  };

  all('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = one('[type="submit"][name="add"]', form);
      if (!button || button.disabled) return;
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
        await refreshCart();
        openPanel(cartDrawer);
        showToast('Added to your bag');
      } catch (error) { showToast(error.message || 'Please try again.'); }
      finally { button.disabled = false; button.innerHTML = original; }
    });
  });

  all('[data-product-section]').forEach((section) => {
    const form = one('[data-product-form]', section);
    const price = one('[data-product-price]', section);
    const atcPrice = one('[data-atc-price]', section);
    const atcText = one('[data-atc-text]', section);
    const atc = one('[name="add"]', form || section);
    all('input[name="id"]', form || section).forEach((radio) => radio.addEventListener('change', () => {
      all('.hh-variant-pills label', form).forEach((label) => label.classList.remove('is-selected'));
      radio.closest('label')?.classList.add('is-selected');
      if (price) price.textContent = radio.dataset.price;
      if (atcPrice) atcPrice.textContent = radio.dataset.price;
      const available = radio.dataset.available !== 'false';
      if (atc) atc.disabled = !available;
      if (atcText) atcText.textContent = available ? 'Add to bag' : 'Sold out';
      if (radio.dataset.mediaId) one(`[data-gallery-thumb="${radio.dataset.mediaId}"]`, section)?.click();
      const mobileBuy = one('[data-mobile-atc]', section);
      if (mobileBuy) mobileBuy.textContent = `${available ? 'Buy' : 'Sold out'} · ${radio.dataset.price}`;
    }));
    one('[data-quantity-minus]', form || section)?.addEventListener('click', () => { const input = one('input[name="quantity"]', form); input.value = Math.max(1, Number(input.value || 1) - 1); });
    one('[data-quantity-plus]', form || section)?.addEventListener('click', () => { const input = one('input[name="quantity"]', form); input.value = Number(input.value || 1) + 1; });
    one('[data-mobile-atc]', section)?.addEventListener('click', () => form?.requestSubmit());
  });

  all('[data-product-gallery]').forEach((gallery) => {
    const media = all('[data-media-id]', gallery);
    const thumbs = all('[data-gallery-thumb]', gallery);
    const count = one('[data-gallery-count]', gallery);
    let index = Math.max(0, media.findIndex((item) => item.classList.contains('is-active')));
    const show = (next) => {
      if (!media.length) return;
      index = (next + media.length) % media.length;
      media.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.setAttribute('aria-hidden', String(i !== index)); });
      thumbs.forEach((item, i) => item.classList.toggle('is-active', i === index));
      if (count) count.textContent = `${index + 1} / ${media.length}`;
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(media.findIndex((item) => item.dataset.mediaId === thumb.dataset.galleryThumb))));
    one('[data-gallery-prev]', gallery)?.addEventListener('click', () => show(index - 1));
    one('[data-gallery-next]', gallery)?.addEventListener('click', () => show(index + 1));
    let startX = null;
    gallery.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', (event) => { if (startX === null) return; const distance = startX - event.changedTouches[0].clientX; if (Math.abs(distance) > 45) show(index + (distance > 0 ? 1 : -1)); startX = null; }, { passive: true });
  });

  all('.hh-sizes').forEach((section) => {
    const tabs = all('[data-size-tab]', section);
    const panels = all('[data-size-panel]', section);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.sizePanel === tab.dataset.sizeTab));
    }));
  });

  const setupRail = (rail) => {
    const section = rail.closest('section');
    one('[data-rail-prev]', section)?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .8, behavior: 'smooth' }));
    one('[data-rail-next]', section)?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .8, behavior: 'smooth' }));
  };
  all('[data-product-rail]').forEach(setupRail);
  all('[data-product-recommendations]').forEach(async (container) => {
    if (!container.dataset.url || container.children.length) return;
    try {
      const response = await fetch(container.dataset.url);
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const incoming = one('[data-product-recommendations]', html);
      if (incoming?.children.length) {
        container.innerHTML = incoming.innerHTML;
        const rail = one('[data-product-rail]', container);
        if (rail) setupRail(rail);
      }
    } catch { container.remove(); }
  });
  all('[data-sort-select]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));

  /* Collection category pills work even when Shopify menu links are not configured. */
  const categoryPills = all('.hh-filter-pills a');
  const collectionCards = all('.hh-collection-grid > .hh-product-card');
  if (categoryPills.length && collectionCards.length) {
    const handle = (value) => value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const cardCategories = (card) => {
      const title = handle(one('h3', card)?.textContent || '');
      if (title === 'draw-me-in') return ['drawstring'];
      if (title === 'dot-dot-done') return ['pouches', 'polka'];
      if (['green-flag-energy', 'lilac-you-mean-it'].includes(title)) return ['pouches', 'gingham'];
      if (['blue-skies-only', 'oat-of-office', 'pinky-promise'].includes(title)) return ['pouches', 'stripes'];
      return ['pouches'];
    };
    collectionCards.forEach((card) => { card.dataset.categories = cardCategories(card).join(' '); });

    const applyCategory = (category, updateUrl = true) => {
      const selected = category === 'shop-all' ? 'all' : category;
      categoryPills.forEach((pill) => pill.classList.toggle('is-active', (pill.dataset.collectionCategory || 'all') === selected));
      collectionCards.forEach((card) => { card.hidden = selected !== 'all' && !card.dataset.categories.split(' ').includes(selected); });
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (selected === 'all') url.searchParams.delete('category'); else url.searchParams.set('category', selected);
        window.history.replaceState({}, '', url);
      }
    };

    categoryPills.forEach((pill, index) => {
      const category = index === 0 ? 'all' : handle(pill.textContent || '');
      pill.dataset.collectionCategory = category;
      pill.href = category === 'all' ? '/collections/all' : `/collections/all?category=${category}`;
      pill.addEventListener('click', (event) => { event.preventDefault(); applyCategory(category); });
    });
    applyCategory(new URLSearchParams(window.location.search).get('category') || 'all', false);
  }
})();
